export default __webpack_public_path__ + "static/media/dti_et.2418f8c9.svg";